<template>
  <div class="upload-courseware-dialog upload-courseware-dialog_wrap">
    <!-- 弹窗头部 -->
    <div class="dialog-header">
      <h3 class="dialog-title">
        添加课件
        <button
          class="add-btn"
          @click="handleAddCourseware"
          :disabled="fileList.length === limit"
        >
          添加({{ fileList.length }}/{{ limit }})
        </button>
      </h3>
    </div>

    <!-- 空状态 -->
    <div class="dialog-content empty" v-if="!fileList.length">
      <div class="empty-state" @click="handleAddCourseware">
        <div class="upload-icon">
          <img
            src="@saas/components/assets/images/courseware/add.png"
            alt="添加课件"
            @click="handleAddCourseware"
          />
        </div>
        <h3 class="empty-title">添加课件</h3>
      </div>
    </div>

    <!-- 弹窗内容 -->
    <div class="dialog-content" v-else>
      <!-- 左侧区域 -->
      <div class="left-panel">
        <!-- 搜索框 -->
        <p class="search-container">默认展示勾选文件</p>

        <!-- 文件列表 -->
        <div class="file-list-container">
          <div class="file-list">
            <div
              v-for="file in fileList"
              :key="file.id"
              class="file-item"
              :class="{
                'file-item-selected': selectedFile?.id === file.id,
              }"
            >
              <!-- 选择状态 -->
              <!-- <div class="file-status" @click="handleFileChecked(index, file)">
                <div class="checkbox" :class="{ checked: file.checked }">
                  <i class="el-icon-check" v-if="file.checked"></i>
                </div>
              </div> -->

              <!-- 文件图标 -->
              <div class="file-icon">
                <img :src="getFileIcon(file)" alt="文件图标" />
              </div>

              <!-- 文件信息 -->
              <div class="file-info">
                <div
                  class="file-name"
                  :title="file.file_name"
                  @click="handleFileSelect(file)"
                >
                  {{ file.file_name }}
                </div>
              </div>

              <!-- 删除文件 -->
              <div class="file-del">
                <img
                  width="20px"
                  src="@saas/components/assets/images/courseware/file-del.png"
                  alt="添加课件"
                  @click="handleFileDelete(file)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分隔线 -->
      <div class="divider"></div>

      <!-- 右侧预览区域 -->
      <div class="right-panel">
        <div class="preview-container">
          <div v-if="!selectedFile" class="preview-empty">
            <p>课件预览区域</p>
          </div>
          <div
            v-else-if="isVideo(selectedFile.file_name)"
            class="preview-video"
          >
            <video :src="selectedFile.transcode_result" ref="videoRef" controls>
              <source :src="selectedFile.transcode_result" />
            </video>
          </div>
          <div
            v-else-if="isImage(selectedFile.file_name)"
            class="preview-image"
          >
            <img :src="selectedFile.transcode_result" alt="" />
          </div>
          <div v-else class="preview-content">
            <!-- 预览图片 -->
            <div class="preview-image">
              <img
                :src="selectedFile.thumbnail + currentPage + '.jpg'"
                alt="预览"
              />
            </div>

            <!-- 页码控制 -->
            <template v-if="selectedFile.pages > 1">
              <div
                v-show="currentPage > 1"
                class="page-btn page-btn_pre"
                @click="handlePrevPage"
              >
                <img
                  src="@saas/components/assets/images/courseware/arrow-left.png"
                  alt=""
                />
              </div>
              <div class="page-info">
                {{ currentPage }}/{{ selectedFile.pages }}
              </div>
              <div
                class="page-btn page-btn_next"
                v-show="currentPage < selectedFile.pages"
                @click="handleNextPage"
              >
                <img
                  src="@saas/components/assets/images/courseware/arrow-right.png"
                  alt=""
                />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <UploadCourseware
      :appendToBody="true"
      :visible.sync="showUploadCourseware"
      ref="uploadCoursewareRef"
      @confirm="handleUploadConfirm"
    />
  </div>
</template>

<script>
import { fileImagebyFileName, isImage, isVideo, isDoc } from "@saas/components";
import { UploadCourseware } from "@saas/components";

export default {
  // name: "UploadCourseware",
  components: {
    UploadCourseware,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      limit: 10,
      fileList: [],
      // 选中文件
      selectedFile: null,
      // 预览相关
      currentPage: 1,
      showUploadCourseware: false,
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetData();
      }
    },
  },
  beforeDestroy() {
    this.$refs.videoRef?.pause();
  },
  methods: {
    // 重置数据
    resetData() {
      this.fileList = [];
      this.selectedFile = null;
      this.currentPage = 1;
    },

    // 文件选择
    handleFileSelect(file) {
      console.log("handleFileSelect file", file);
      this.selectedFile = file;
      this.currentPage = 1;
    },

    // 上一页
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    // 下一页
    handleNextPage() {
      if (this.currentPage < this.selectedFile.pages) {
        this.currentPage++;
      }
    },

    // 获取文件图标
    getFileIcon(file) {
      return fileImagebyFileName(file.file_name);
    },

    // 处理图片加载错误
    handleImageError(event) {
      event.target.style.display = "none";
      // 可以显示一个默认的占位图
    },

    // 添加课件
    handleAddCourseware() {
      if (this.fileList.length === this.limit) {
        return;
      }

      this.showUploadCourseware = true;
    },
    handleUploadConfirm(file) {
      if (this.fileList.some((item) => item.id === file.id)) {
        this.$message.warning("课件已存在");
        return;
      }
      file.checked = false;
      console.log("handleUploadConfirm file", file);
      this.fileList.push(file);
      this.currentPage = 1;
      this.selectedFile = file;
      this.showUploadCourseware = false;
    },
    handleFileDelete(file) {
      this.fileList = this.fileList.filter((item) => item.id !== file.id);
    },
    handleFileChecked(index, file) {
      console.log("handleFileChecked index, file", index, file);
      file.checked = !file.checked;
      this.$set(this.fileList, index, file);
    },
    isVideo(fileName) {
      return isVideo(fileName);
    },
    isImage(fileName) {
      return isImage(fileName);
    },
    isDoc(fileName) {
      return isDoc(fileName);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-courseware-dialog_wrap {
  --courseware-dialog-bg: var(--mg-bg-card);
  --courseware-content-bg: var(--mg-bg-card);
  --courseware-surface-bg: var(--mg-bg-surface);
  --courseware-preview-bg: var(--mg-control-hover-bg);
  --courseware-preview-image-bg: var(--mg-warning-soft-bg);
  --courseware-primary: var(--mg-text-primary);
  --courseware-secondary: var(--mg-text-secondary);
  --courseware-border: var(--mg-border-subtle);
  --courseware-hover-bg: var(--mg-control-hover-bg);
  --courseware-selected-bg: var(--mg-brand-soft-bg);
  --courseware-selected-text: var(--mg-text-primary);
}

.upload-courseware-dialog_wrap ::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background: var(--courseware-dialog-bg);
    border-radius: 24px;
  }
  .upload-courseware-dialog {
    border-radius: 24px;
    .el-dialog__body {
      padding: 0;
    }
  }
}

.upload-courseware-dialog_wrap .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 0 16px 20px;

  .dialog-title {
    height: 28px;
    line-height: 28px;
    font-size: 20px;
    font-weight: 600;
    color: var(--courseware-primary);
    margin: 0;
  }

  .add-btn {
    margin-left: 16px;
    background: var(--courseware-content-bg);
    border-radius: 8px;
    border: 1px solid var(--courseware-border);
    font-weight: 600;
    font-size: 14px;
    color: var(--mg-brand-primary);
    line-height: 20px;
    height: 32px;
    padding: 0 12px;
    text-align: center;
    &:hover {
      background: var(--courseware-hover-bg);
      color: var(--mg-brand-primary);
    }
  }
}

.dialog-content {
  display: flex;
  margin: 0 20px;
  border-radius: 12px;
  border: 1px solid var(--courseware-border);
  background: var(--courseware-content-bg);
  height: 300px;

  &.empty {
    justify-content: center;
    align-items: center;
    background: var(--courseware-surface-bg);
    border-radius: 12px;
    border: 2px dashed var(--courseware-border);
    padding: 80px 0;
    transition: all 0.3s ease;

    .empty-state {
      text-align: center;
      cursor: pointer;
      padding: 10px;

      .upload-icon {
        margin-bottom: 16px;

        img {
          width: 64px;
          height: 64px;
          opacity: 0.6;
          cursor: pointer;
        }
      }

      .empty-title {
        font-size: 18px;
        font-weight: 600;
        color: var(--courseware-primary);
        margin: 0 0 8px 0;
      }

      .empty-desc {
        font-size: 14px;
        color: var(--courseware-secondary);
        margin: 0;
      }
    }
  }

  .left-panel {
    width: 420px;
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    border-radius: 12px 0 0 12px;

    .search-container {
      font-weight: 400;
      font-size: 12px;
      color: var(--courseware-secondary);
      line-height: 17px;
      margin-left: 16px;
      margin-bottom: 8px;
    }

    .file-list-container {
      flex: 1;
      overflow-y: auto;
      background: var(--courseware-content-bg);
      border-radius: 8px;

      // 自定义滚动条样式
      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: var(--courseware-border);
        border-radius: 2px;

        &:hover {
          background: var(--courseware-secondary);
        }
      }

      &::-webkit-scrollbar-corner {
        background: transparent;
      }

      // Firefox滚动条样式
      scrollbar-width: thin;
      scrollbar-color: var(--courseware-border) transparent;

      .file-list {
        .file-item {
          display: flex;
          align-items: center;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          margin-bottom: 4px;
          min-height: 40px;
          box-sizing: border-box;
          transition: all 0.2s ease;

          &.file-item-selected {
            background: var(--courseware-selected-bg);

            .file-name {
              color: var(--courseware-selected-text);
            }
          }

          .file-del {
            display: none;
            margin-right: 8px;
          }

          &:hover {
            background-color: var(--courseware-hover-bg);
            .file-del {
              display: block;
            }
          }

          .file-icon {
            width: 24px;
            height: 24px;
            margin-left: 6px;
            margin-right: 6px;
            flex-shrink: 0;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .file-info {
            flex: 1;
            min-width: 0;

            .file-name {
              font-size: 14px;
              font-weight: 500;
              color: var(--courseware-primary);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              // margin-bottom: 4px;
            }
          }

          .file-status {
            margin-left: 8px;

            .checkbox {
              width: 16px;
              height: 16px;
              border: 2px solid var(--courseware-border);
              border-radius: 3px;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.2s ease;

              &.checked {
                background: var(--mg-brand-primary);
                border-color: var(--mg-brand-primary);
                color: var(--mg-text-inverse);
              }

              i {
                font-size: 10px;
                color: var(--mg-text-inverse);
              }
            }
          }
        }
      }
    }
  }

  .divider {
    width: 1px;
    background-color: var(--courseware-border);
  }

  .right-panel {
    flex: 1;
    padding: 24px 60px;
    position: relative;
    // 自定义滚动条样式
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--courseware-border);
      border-radius: 2px;

      &:hover {
        background: var(--courseware-secondary);
      }
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }

    // Firefox滚动条样式
    scrollbar-width: thin;
    scrollbar-color: var(--courseware-border) transparent;

    .preview-container {
      height: 100%;
      border: 1px solid var(--courseware-border);
      border-radius: 12px;
      overflow: hidden;
      background-color: var(--courseware-preview-bg);
      display: flex;
      flex-direction: column;

      .preview-empty {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: var(--courseware-secondary);
        font-size: 16px;
      }

      .preview-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        // 自定义滚动条样式
        &::-webkit-scrollbar {
          width: 4px;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background: var(--courseware-border);
          border-radius: 2px;

          &:hover {
            background: var(--courseware-secondary);
          }
        }

        &::-webkit-scrollbar-corner {
          background: transparent;
        }

        // Firefox滚动条样式
        scrollbar-width: thin;
        scrollbar-color: var(--courseware-border) transparent;

        .preview-image {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: var(--courseware-preview-image-bg);
          img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
          }
        }

        .page-btn {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.2);
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          &.disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .arrow-left,
          .arrow-right {
            color: var(--mg-text-inverse);
            font-size: 20px;
            font-weight: bold;
            line-height: 1;
          }
          &.page-btn_pre {
            left: 14px;
          }
          &.page-btn_next {
            right: 14px;
          }
        }

        .page-info {
          position: absolute;
          width: 44px;
          height: 16px;
          background: #000000;
          border-radius: 8px;
          opacity: 0.5;
          bottom: 36px;
          left: 50%;
          transform: translate(-50%);
          font-weight: 500;
          font-size: 12px;
          color: var(--mg-text-inverse);
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .preview-video,
      .preview-image {
        flex: 1;
        overflow: hidden;
        video {
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}

html.dark .upload-courseware-dialog_wrap {
  --courseware-dialog-bg: var(--mg-bg-elevated);
  --courseware-content-bg: var(--mg-bg-elevated);
  --courseware-surface-bg: var(--mg-bg-surface);
  --courseware-preview-bg: var(--mg-bg-card);
  --courseware-preview-image-bg: var(--mg-bg-surface);
  --courseware-primary: var(--mg-text-primary);
  --courseware-secondary: var(--mg-text-secondary);
  --courseware-border: var(--mg-border-subtle);
  --courseware-hover-bg: var(--mg-control-hover-bg);
  --courseware-selected-bg: var(--mg-brand-soft-bg);
  --courseware-selected-text: var(--mg-text-primary);

  .dialog-title,
  .empty-title,
  .search-container,
  .file-name,
  .preview-empty {
    color: var(--courseware-primary);
  }

  .search-container,
  .preview-empty {
    color: var(--courseware-secondary);
  }
}
</style>
